import(/* webpackMode: "eager" */ "/app/apps/web/app/(use-page-wrapper)/(main-nav)/availability/error.tsx");
